export enum ReviewEntryProcessingStatus {
  Processing = 'processing',
  Received = 'received',
}
